import { c as _c } from "react/compiler-runtime";
interface DataGridFooterProps {
  current: number;
  total: number;
  label: string;
}
export const DataGridFooter = t0 => {
  const $ = _c(4);
  const {
    current,
    total,
    label
  } = t0;
  let t1;
  if ($[0] !== current || $[1] !== label || $[2] !== total) {
    t1 = <div className="text-xs text-gray-600 dark:text-gray-400">{current} / {total} {label}</div>;
    $[0] = current;
    $[1] = label;
    $[2] = total;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};